import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {UserListItem} from '@/common-pages/invitation/invitation.type';
import {toPriceStr} from '@/utils';
import DoubleRowProgress from './double-row-progress';
import SingleRowProgress from './single-row-progress';
import CoinItem from './coin-item';
import UserInfoItem from './user-info-item';
export interface InvitationBigProgressProps {
  userList?: UserListItem[];
}

const InvitationBigProgress: React.FC<InvitationBigProgressProps> = ({
  userList,
}) => {
  const {t} = useTranslation();
  const listLength = useMemo(() => {
    if (!userList) {
      return 0;
    }
    return Math.min(userList.length, 12);
  }, [userList]);

  // 判断是否需要双排显示
  const isDoubleRow = listLength > 6;
  const nextUserItem = useMemo(() => {
    if (!userList) {
      return;
    }
    const resultItem = userList
      .slice(0, listLength)
      .find(item => item.invitedNumber < item.inviteNumber);
    return resultItem || userList[listLength - 1];
  }, [userList, listLength]);
  const reachedCount = useMemo(() => {
    if (!userList) {
      return 0;
    }
    return userList
      .slice(0, listLength)
      .filter(
        item => item.invitedNumber >= item.inviteNumber && item.status === 1,
      ).length;
  }, [userList, listLength]);

  const showList = useMemo(() => {
    if (!userList) {
      return [];
    }
    return userList.slice(0, listLength);
  }, [userList, listLength]);

  // 计算上下排分组
  const {topRow, bottomRow} = useMemo(() => {
    if (!isDoubleRow) {
      return {topRow: showList, bottomRow: []};
    }
    const half = Math.ceil(listLength / 2);
    return {
      topRow: showList.slice(0, half),
      bottomRow: showList.slice(half),
    };
  }, [showList, listLength, isDoubleRow]);

  return (
    <div className="flex flex-col rounded-lg py-3 gap-2 bg-white">
      <div className="flex flex-row items-center justify-center px-3">
        <span className="text-black text-xs font-bold">
          {t('agent.invitation-reward.additionalRewards')}
        </span>
      </div>
      <div className="flex flex-row items-center justify-center py-3">
        <span className="font-bold text-[2rem] text-[#F15802]">
          {toPriceStr(nextUserItem?.bonusAmount || 0, {fixed: 0})}
        </span>
      </div>
      {/* 进度部分 */}
      {isDoubleRow ? (
        <DoubleRowProgress
          topRow={topRow}
          bottomRow={bottomRow}
          reachedCount={reachedCount}
          renderTopContent={item => (
            <CoinItem bonusAmount={item.bonusAmount || 0} />
          )}
          renderBottomContent={item => (
            <UserInfoItem
              invitedNumber={item.invitedNumber}
              inviteNumber={item.inviteNumber}
            />
          )}
        />
      ) : (
        <SingleRowProgress
          items={showList}
          reachedCount={reachedCount}
          renderTopContent={item => (
            <CoinItem bonusAmount={item.bonusAmount || 0} />
          )}
          renderBottomContent={item => (
            <UserInfoItem
              invitedNumber={item.invitedNumber}
              inviteNumber={item.inviteNumber}
            />
          )}
        />
      )}
    </div>
  );
};

export default InvitationBigProgress;
